import './styles.scss'
import React from 'react'
import { TRADE_BOX } from 'Utils/Constants'

function CoffeeTradeBox() {
  return (
    <div className="trade-box-container">
      <video controls className="trade-box-image" autoPlay loop playsInline>
        <source src={TRADE_BOX.video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

export default CoffeeTradeBox
